module.exports = __webpack_public_path__ + "static/media/img_solution_four.810c7020.png";